import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { CardDistribuicaoLimiteLgComponent } from './components/card-distribuicao-limite-lg/card-distribuicao-limite-lg.component';
import { CardGarantiaLgComponent } from './components/card-garantia-lg/card-garantia-lg.component';
import { CardLimiteCreditoLgComponent } from './components/card-limite-credito-lg/card-limite-credito-lg.component';
import { ModalAjusteLimiteLgComponent } from './components/modal-ajuste-limite-lg/modal-ajuste-limite-lg.component';
import { ModalAjusteRealizadoLgComponent } from './components/modal-ajuste-realizado-lg/modal-ajuste-realizado-lg.component';
import { ModalAvisoFinanciamentoLgComponent } from './components/modal-aviso-financiamento-lg/modal-aviso-financiamento-lg.component';
import { LimiteGlobalComponent } from './limite-global.component';
import { LimiteGlobalService } from './limite-global.service';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		RouterModule,
		MatSliderModule,
		ReactiveFormsModule,
		FormsModule,
		MatProgressSpinnerModule,
	],
	entryComponents: [
		ModalAvisoFinanciamentoLgComponent,
		ModalAjusteLimiteLgComponent,
		ModalAjusteRealizadoLgComponent,
	],
	declarations: [
		LimiteGlobalComponent,
		CardGarantiaLgComponent,
		CardLimiteCreditoLgComponent,
		ModalAvisoFinanciamentoLgComponent,
		CardDistribuicaoLimiteLgComponent,
		ModalAjusteLimiteLgComponent,
		ModalAjusteRealizadoLgComponent,
	],
	providers: [LimiteGlobalService],
})
export class LimiteGlobalModule {}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/limite-global/limite-global.module.ts